// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECK-IN!
/* tslint:disable */
export const BuildInfo = {
    "dirty": true,
    "raw": "v1.8.1-6401-g708625ae7-dirty",
    "hash": "g708625ae7",
    "distance": 6401,
    "tag": "v1.8.1",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v1.8.1",
        "major": 1,
        "minor": 8,
        "patch": 1,
        "prerelease": [],
        "build": [],
        "version": "1.8.1"
    },
    "suffix": "6401-g708625ae7-dirty",
    "semverString": "1.8.1+6401.g708625ae7",
    "version": "3.2.2"
};
/* tslint:enable */
